// extracted by mini-css-extract-plugin
module.exports = {"container":"VectorCoordinate_container__2-aIR","title":"VectorCoordinate_title__2uZIl","button":"VectorCoordinate_button__3YSLI","table":"VectorCoordinate_table__NLKpU"};